import Axios from 'axios';
import { cache } from '.';

const isTokenExpiredError = (error: any): boolean => (
  error.response?.status === 401 &&
  /token|expired/i.test(error.response.data?.message || '')
);

export const configureInterceptor = () => {
  Axios.interceptors.response.use(
    response => response,
    error => {
      if (isTokenExpiredError(error)) {
        cache.del('TOKEN');
        cache.del('USER');
        cache.set('session_expired', 'true');
        window.location.href = '/';
        return new Promise(() => {});
      }
      return Promise.reject(error);
    }
  );
};